import { Box } from '@material-ui/core';
import { ArticleTypeExternal, formatMoney, Money } from '@nemuru-eng/js-api-client';

import { Font } from '@/components/shared/components/Font';
import { IconHeader } from '@/components/shared/components/IconHeader';
import { ICON_NAMES } from '@/config/config';

interface DialogHeaderProps {
  total: Money;
  articleType: ArticleTypeExternal;
  articleDetailId: string;
}

export const DialogHeader = ({ total, articleType, articleDetailId }: DialogHeaderProps) => {
  const headerParamsByArticleType = (): {
    labelTid: string;
    surLabelTid: string;
    iconName?: string;
  } => {
    switch (articleType) {
      case ArticleTypeExternal.SERVICE:
        return {
          labelTid: 'SERVICE',
          surLabelTid: 'ARTICLE',
        };
      case ArticleTypeExternal.FLIGHT:
        return {
          labelTid: 'FLIGHT',
          surLabelTid: 'ARTICLE',
          iconName: ICON_NAMES.FLIGHT_SMALL,
        };
      case ArticleTypeExternal.PRODUCT:
        return {
          labelTid: 'ONLINE_PRODUCT',
          surLabelTid: 'ARTICLE',
        };
      case ArticleTypeExternal.ACCOMMODATION:
        return {
          labelTid: 'ACCOMMODATION',
          surLabelTid: 'ARTICLE',
        };
      case ArticleTypeExternal.TRAVEL:
        return {
          labelTid: 'TRAVEL',
          surLabelTid: 'ARTICLE',
        };
      case ArticleTypeExternal.AUTOMOBILE:
        return {
          labelTid: 'AUTO',
          surLabelTid: 'ARTICLE',
        };
      default:
        return {
          labelTid: 'ONLINE_PRODUCT',
          surLabelTid: 'ARTICLE',
          iconName: ICON_NAMES.ONLINE_PRODUCT,
        };
    }
  };

  const headerParams = headerParamsByArticleType();

  const articleTypeExternalKey =
    Object.keys(ArticleTypeExternal)[Object.values(ArticleTypeExternal).indexOf(articleType)];

  return (
    <Box width={'100%'} display={'inline-flex'} alignItems={'center'} justifyContent={'space-between'} pb={2}>
      <Box>
        <IconHeader
          labelTid={headerParams.labelTid}
          surLabelTid={headerParams.surLabelTid}
          iconName={headerParams.iconName ?? ICON_NAMES[articleTypeExternalKey]}
          color={'secondary'}
          copyToClipboard={{ value: articleDetailId, textId: 'COPY_ARTICLE_ID' }}
        />
      </Box>

      <Font variant={'h2'} color={'title'}>
        {formatMoney({ value: total.value, currency: total.currency })}
      </Font>
    </Box>
  );
};
